import React from 'react';
import PropTypes from 'prop-types';
import { Link, Center, Text } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';

const FooterLink = ({ text, href, ...containerProps }) => {
  return (
    <Link href={href} isExternal {...containerProps}>
      <Center>
        <Text color="white">{text}</Text>
        <ExternalLinkIcon ml="2" />
      </Center>
    </Link>
  );
};

FooterLink.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};

FooterLink.defaultProps = {};

export default FooterLink;
